// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-private',
  defaultApp: 'routeoptimizer',
  apiUrl: 'https://1rqgfkzncb.execute-api.us-east-1.amazonaws.com/prod'
};
